module.exports = __webpack_public_path__ + "img/7.disabled.8045bbce.svg";